var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }